module.exports = __webpack_public_path__ + "static/media/opp_main_logo.a58c0a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/opp_main_logo.png
// module id = 1931
// module chunks = 1